export enum BACKEND_ERROR_TYPES {
	FEATURE_ACCESS_DENIED = 'FEATURE_ACCESS_DENIED',
	WORKSPACE_ACCESS_DENIED = 'WORKSPACE_MISMATCH',
	FORM_ACCESS_DENIED = 'NO_FORM_ACCESS',
	FREEMIUM_LIMIT_REACHED = 'FREEMIUM_LIMIT_REACHED',
}

export enum RATE_LIMIT_TYPES {
	AI_CREDITS = 'AI_CREDITS',
	REPLIES = 'REPLIES',
	INTERVIEWS = 'INTERVIEWS',
	ASSIGNMENTS = 'ASSIGNMENTS',
	STAGE_CHANGES = 'STAGE_CHANGES',
	OFFERS = 'OFFERS',
}

export enum BACKEND_ERROR_CODES {
	FORM_OUTDATED = 4013,
}
